<div class="notice">
  <div class="top">
    <mat-icon class="close" mat-dialog-close>close</mat-icon>
  </div>
  <div class="title">
    <img src="../../../../../assets/images/pre-purchase.png" alt="" />买前须知
  </div>
  <div class="subtitle">*请在下单前确认已充分了解相关使用风险</div>
  <div class="divider"></div>
  <div class="content" mat-dialog-content>
    <div class="item">
      <div class="txt1">风险说明</div>
      <div class="txt2">
        由于 Netflix
        官方持续升级风控策略，账号在使用过程中可能会出现不定期验证、限制或封锁等情况。上述情况属于官方风控行为，平台无法进行干预处理。
      </div>
    </div>
    <div class="item item2">
      <div class="txt1">不提供售后支持</div>
      <div class="txt2">
        若账号后续因官方风控出现验证、限制或封锁等情况，平台无法提供任何售后支持，请确认后购买。
      </div>
    </div>
    <div class="check">
      <input
        type="checkbox"
        [checked]="checked"
        (change)="checked = !checked"
      />
      <span>我已阅读并理解上述风险提示</span>
    </div>
  </div>
  <div class="button">
    <button
      matRipple
      (click)="onOk()"
      [disabled]="!checked"
      [ngStyle]="{
        background: !checked ? '#81E0D8' : '#2DB5A9',
        cursor: !checked ? '' : 'pointer'
      }"
    >
      我已知悉并继续购买
    </button>
  </div>
</div>
